import React, { useEffect, useState, useRef } from 'react';
import { TextInput, Card, Flex, ColorPicker } from '@mantine/core';
// import { useDisclosure } from '@mantine/hooks';
import { Icon } from '@shakkerai/components';

import { toRgb, toHex, getRGBA } from './utils';
import Straw from './straw.png';
import { translate } from '@shakkerai/util-i18n';
import ColorPipette from './colorPipette';
import { setTempState, useTempState } from '@starflow/app/store';
import gridOpacity from './opacity_background.png';
import { convertImageUrl2ImageElement } from '@shakkerai/pro-atoms';

export const PickerPanel = ({ color, onChange, format = 'rgba', onClose = () => {} }) => {
  const [showEyeDropper, setShowEyeDropper] = useState(false);
  const isMaskExist = useTempState('isMaskExist');
  const textInputRef = useRef();
  const rRef = useRef();
  const gRef = useRef();
  const bRef = useRef();
  const aRef = useRef();

  useEffect(() => {
    setShowEyeDropper(!!window.EyeDropper);
  }, []);

  // 自定义输入框样式
  const inputHexStyle = () => {
    return {
      input: {
        textAlign: 'center',
        paddingInlineStart: '20px',
        width: '100%',
        fontSize: '12px',
        minHeight: '26px',
        height: '26px',
      },
      section: {
        top: '4px',
        width: '24px',
        fontSize: '12px',
      },
    };
  };
  // 自定义输入框样式
  const inputRgbStyle = () => {
    return {
      input: {
        textAlign: 'right',
        paddingInlineStart: '20px',
        width: '100%',
        fontSize: '12px',
        minHeight: '24px',
        height: '24px',
      },
      section: {
        top: '4px',
        width: '24px',
        fontSize: '12px',
      },
    };
  };

  const setColor = (color) => {
    // HEX回填
    if (textInputRef.current) {
      textInputRef.current.value = toHex(color).replace('#', '').toUpperCase();
    }
    // rgba回填
    const { r, g, b, a } = getRGBA(color);
    rRef.current && (rRef.current.value = r);
    gRef.current && (gRef.current.value = g);
    bRef.current && (bRef.current.value = b);
    aRef.current && (aRef.current.value = a * 100);
  };

  // hex监听
  const onHEXColorChange = (color) => {
    // console.log('xxx onHEXColorChange', color)
    const rgbacolor = toRgb(color);
    onChange(rgbacolor);
    setColor(color);
  };

  // rgba监听
  const onRgbaColorChange = (type, value) => {
    console.log('xxx onRgbaColorChange', type, value);
    if (type === 'a') {
      value = value / 100 || 100;
    }
    const { r, g, b, a } = {
      ...getRGBA(color),
      [type]: value,
    };
    const rgba = `rgba(${r},${g},${b},${a})`;
    onChange(rgba);
    setColor(rgba);
  };

  // 取色器
  const handelEyeDropper = async () => {
    // const eyeDropper = new EyeDropper();
    // eyeDropper
    //   .open()
    //   .then((color) => {
    //     onHEXColorChange(color.sRGBHex);
    //   })
    //   .catch((e) => {});
    // const canvasContainer = document.querySelector('.konvajs-content')
    let pipette2;
    const canvasContainer = document.getElementById('element-canvas');
    const pipette1 = new ColorPipette({
      // container: document.body,
      background: '#F1F2F3',
      container: canvasContainer,
      scale: 2,
      afterDestroy: () => {
        setTempState({
          isMaskExist: true,
        });
      },
      listener: {
        onOk: ({ color }) => {
          // console.log(color, colors);
          onHEXColorChange(color);
          pipette2?.destroy();
          setTempState({
            isMaskExist: true,
          });
        },
      },
    });
    pipette1.start();
    const pic = document.getElementById('color-reference-picture');
    setTempState({
      isMaskExist: false,
    });
    if (pic) {
      const backgroundImage = await convertImageUrl2ImageElement(gridOpacity);
      pipette2 = new ColorPipette({
        // container: document.body,
        background: backgroundImage,
        container: pic,
        scale: 2,
        listener: {
          onOk: ({ color }) => {
            // console.log(color, colors);
            onHEXColorChange(color);
            pipette1.destroy();
            setTempState({
              isMaskExist: true,
            });
          },
        },
      });
      pipette2.start();
    }
  };

  // const pickerImgContainer = document.querySelector('.picker-panel-picker')?.querySelector('.mantine-ColorPicker-body')
  // console.log('xxx pickerImgContainer',pickerImgContainer)

  return (
    <Card shadow="sm" radius="md" withBorder={false} className="cursor-default color-picker-panel">
      {/* <Card.Section withBorder inheritPadding>
        <Flex h={44} align="center" className="justify-between">
          <span className="text-sm text-[#2d2d2d] font-semibold">{translate('color_para_title3')}</span>
          <Icon fontSize={16} className="icon-border_close-1 cursor-pointer" onClick={onClose} />
        </Flex>
      </Card.Section> */}
      <Card.Section className="p-[12px] text-xs">
        <ColorPicker
          saturationLabel="Saturation"
          hueLabel="Hue"
          alphaLabel="Alpha"
          className="picker-panel-picker"
          fullWidth
          format={format}
          value={color}
          onChangeEnd={onHEXColorChange}
          onChange={onHEXColorChange}
        />
        <Flex h={26} align="center" gap="md" className="mt-[12px]">
          {/* {showEyeDropper && (
            <img src={Straw} className="icon-home_cloese cursor-pointer w-[20px] h-[20px]" onClick={handelEyeDropper} />
          )} */}
          {
            <img
              src={Straw}
              className={`icon-home_cloese cursor-pointer w-[20px] h-[20px] hover:bg-[#f4f6f8] ${
                !isMaskExist ? 'bg-[#f4f6f8]' : ''
              }`}
              onClick={handelEyeDropper}
            />
          }
          <TextInput
            ref={textInputRef}
            variant="filled"
            className="hex w-full"
            styles={inputHexStyle}
            leftSection="#"
            defaultValue={toHex(color).replace('#', '').toUpperCase()}
            onBlur={(e) => {
              onHEXColorChange(e.currentTarget.value);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                onHEXColorChange(e.currentTarget.value);
              }
            }}
          />
        </Flex>
        <Flex h={24} align="center" gap={6} className="mt-[12px]">
          <TextInput
            ref={rRef}
            variant="filled"
            className="rgba"
            styles={inputRgbStyle}
            leftSection="R"
            defaultValue={getRGBA(color).r}
            onBlur={(e) => {
              onRgbaColorChange('r', e.currentTarget.value);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                onRgbaColorChange('r', e.currentTarget.value);
              }
            }}
          />
          <TextInput
            ref={gRef}
            variant="filled"
            className="rgba"
            styles={inputRgbStyle}
            leftSection="G"
            defaultValue={getRGBA(color).g}
            onBlur={(e) => {
              onRgbaColorChange('g', e.currentTarget.value);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                onRgbaColorChange('g', e.currentTarget.value);
              }
            }}
          />
          <TextInput
            ref={bRef}
            variant="filled"
            className="rgba"
            styles={inputRgbStyle}
            leftSection="B"
            defaultValue={getRGBA(color).b}
            onBlur={(e) => {
              onRgbaColorChange('b', e.currentTarget.value);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                onRgbaColorChange('b', e.currentTarget.value);
              }
            }}
          />
          {format === 'rgba' && (
            <TextInput
              ref={aRef}
              variant="filled"
              className="rgba"
              styles={inputRgbStyle}
              leftSection="A"
              defaultValue={getRGBA(color).a * 100}
              onBlur={(e) => {
                onRgbaColorChange('a', e.currentTarget.value);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  onRgbaColorChange('a', e.currentTarget.value);
                }
              }}
            />
          )}
        </Flex>
      </Card.Section>
    </Card>
  );
};

// const AC = ()=> {
//   const [portalContainer, setPortalContainer] = useState(null);
//   useEffect(()=>{
//     const container = document.querySelector('.picker-panel-picker')?.querySelector('.mantine-ColorPicker-body')
//     // console.log('xxx,container', container.toString())
//     const d = document.createElement('div')
//     container.append(d)
//     setPortalContainer(d)
//   },[])
//   if(portalContainer instanceof HTMLElement){
//     try{
//       const a =  createPortal(
//         (
//           <img src={Straw} className="icon-home_cloese cursor-pointer w-[20px] h-[20px]" />,
//           portalContainer
//         ))
//         console.log('xxx',a)
//     }catch(e) {
//       debugger
//     }

//   }

//   return null
// }
